<template>
  <Card dis-hover>
    <p slot="title">
      <Icon type="ios-bookmark"></Icon>
      切换用户
    </p>
    <Form
      ref="userForm"
      :rules="AnonymousLoginModelRule"
      :model="model"
      :label-width="120"
      style="width: 520px"
    >
      <FormItem label="切换用户账号" prop="UserName">
        <Input v-model="model.UserName" type="text"></Input>
      </FormItem>
      <FormItem>
        <Button @click="save" type="primary">确认</Button>
        &nbsp;&nbsp;
      </FormItem>
    </Form>
  </Card>
</template>
<script>
import Util from "../../../lib/util";
import appconst from "../../../lib/appconst";
export default {
  components: {},
  name: "anonymousLogin",
  data() {
    return {
      model: {
        UserName: "",
      },
      AnonymousLoginModelRule: {
        UserName: [
          { required: true, message: "必填项不能为空", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    async save() {
      this.$refs.userForm.validate(async (valid) => {
        if (valid) {
          let reponse = await this.$Ajax.post(
            `api/TokenAuth/AnonymousLogin`,
            this.model
          );
          if (reponse.data.success) {
            this.$Message.success("切换成功！");
            Util.abp.auth.clearToken();
            var tokenExpireDate = new Date(
              new Date().getTime() + 1000 * reponse.data.result.expireInSeconds
            );
            Util.abp.auth.setToken(
              reponse.data.result.accessToken,
              tokenExpireDate
            );
            Util.abp.utils.setCookieValue(
              appconst.authorization.encrptedAuthTokenName,
              reponse.data.result.encryptedAccessToken,
              tokenExpireDate,
              Util.abp.appPath
            );
            this.$router.push({
              name: 'main',
            });
            location.reload();
          }
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.group {
  display: flex;
  flex-flow: row;
  justify-content: space-between;
}
</style>
